export const MAX_CHUNK_CHARS = 180;
export const MAX_CHUNK_BYTES = 4096;
export const MAX_CONCURRENCY = 3;
export const CHUNK_RETRY_LIMIT = 2;
export const AUDIO_SAMPLE_RATE = 24000;
export const AUDIO_CHANNELS = 1;
export const AUDIO_BIT_DEPTH = 16;

